import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl',
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value: any, args?: any): any {
    if(args && args.noPropertyBinding){
      return this.sanitized.sanitize(SecurityContext.URL, this.sanitized.bypassSecurityTrustResourceUrl(value));
    }else{
      return this.sanitized.bypassSecurityTrustResourceUrl(value)
    }    
  }
}
